import type { ReactNode } from "react"

/**
 * Shared wrapper for metric-list cards (e.g. Live Metrics, Daily Totals,
 * Monthly Totals) used by both plant and For-Hire dashboards.
 *
 * Owns the outer card chrome, header, and inner stacking container so all
 * sibling cards render at the same padding and gap.
 */
export default function MetricsCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="rounded-md shadow-sm p-3 border bg-card">
      <h2 className="text-lg font-semibold">{title}</h2>
      <div className="flex flex-col gap-2 mt-2">{children}</div>
    </div>
  )
}
